import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import NewsletterJourneyTracker from "./components/NewsletterJourneyTracker";
import HomePage from "./pages/HomePage";

const WebDesignPage = lazy(() => import("./pages/WebDesignPage"));
const LandingPagesPage = lazy(() => import("./pages/LandingPagesPage"));
const UiUxDesignPage = lazy(() => import("./pages/UiUxDesignPage"));
const BrandIdentityPage = lazy(() => import("./pages/BrandIdentityPage"));
const DigitalMarketingAssetsPage = lazy(() => import("./pages/DigitalMarketingAssetsPage"));
const CustomOnlineSystemsPage = lazy(() => import("./pages/CustomOnlineSystemsPage"));
const SocialMediaManagementPage = lazy(() => import("./pages/SocialMediaManagementPage"));
const WebApplicationDevelopmentPage = lazy(() => import("./pages/WebApplicationDevelopmentPage"));
const MobileApplicationDevelopmentPage = lazy(() => import("./pages/MobileApplicationDevelopmentPage"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const BlogEditorPage = lazy(() => import("./pages/BlogEditorPage"));
const BlogPostPage = lazy(() => import("./pages/BlogPostPage"));
const BookingPage = lazy(() => import("./pages/BookingPage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const IndustryPage = lazy(() => import("./pages/IndustryPage"));
const CaliforniaDigitalAgencyPage = lazy(() => import("./pages/CaliforniaDigitalAgencyPage"));
const DesignConceptsPage = lazy(() => import("./pages/DesignConceptsPage"));
const AuditToolPage = lazy(() => import("./pages/AuditToolPage"));
const AnalyticsToolPage = lazy(() => import("./pages/AnalyticsToolPage"));

function App() {
  return (
    <>
      <ScrollToTop />
      <NewsletterJourneyTracker />
      <Suspense fallback={<div className="min-h-screen bg-white" aria-label="Loading page" />}>
        <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/web-design" element={<WebDesignPage />} />
        <Route path="/landing-pages" element={<LandingPagesPage />} />
        <Route path="/ui-ux-design" element={<UiUxDesignPage />} />
        <Route path="/brand-identity" element={<BrandIdentityPage />} />
        <Route path="/digital-marketing-assets" element={<DigitalMarketingAssetsPage />} />
        <Route path="/custom-online-systems" element={<CustomOnlineSystemsPage />} />
        <Route path="/social-media-management" element={<SocialMediaManagementPage />} />
        <Route path="/web-application-development" element={<WebApplicationDevelopmentPage />} />
        <Route path="/mobile-application-development" element={<MobileApplicationDevelopmentPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/editor" element={<BlogEditorPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/design-concepts" element={<DesignConceptsPage />} />
        <Route path="/audit-tool" element={<AuditToolPage />} />
        <Route path="/analytics-tool" element={<AnalyticsToolPage />} />
        <Route path="/industries/:industryId" element={<IndustryPage />} />
        <Route path="/california-digital-agency" element={<CaliforniaDigitalAgencyPage />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
